import getEnvironment from '../GetEnvironment';

/**
 * Ortama göre varsayılan terminal grubu.
 *
 * ⚠️ ORTAMA DUYARLI OLMAK ZORUNDA. Bu değer bir dönem Redux başlangıç durumunda
 * (`mmid`) ortam kontrolü olmadan TEST sabitine gömülüydü; token cevabı terminal
 * grubunu taşımadığında canlıda da test terminaline düşüyordu.
 *
 * Yalnızca SON ÇARE olarak kullanılır — öncelik her zaman token cevabındaki
 * `MpTerminalGroupId`, sonra `MacroMerchantId`.
 */
export const defaultTerminalGroupId = (): string =>
  getEnvironment() ? '05878207920408103103242' : '06580207920724020852449';

export default defaultTerminalGroupId;
